module.exports = "/_next/static/images/receive@2x-a737ea24898fe378dd004dc9a3f95fad.png";